<div class="login-container">
  <mat-card class="login-card">
    <mat-card-header class="header-holder">
      <img
        priority
        ngSrc="assets/talentmarket.logo.svg"
        routerLink="/home"
        alt="talentmarket."
        class="logo-card cursor-pointer"
        height="100"
        width="250" />
    </mat-card-header>

    <mat-card-content>
      <h2 class="login-title">Candidate Login</h2>

      <form [formGroup]="loginFormGroup" (ngSubmit)="signIn()" class="form-holder">
        <mat-form-field appearance="fill" class="width-full">
          <input
            matInput
            id="email"
            type="email"
            required
            formControlName="email"
            placeholder="Email"
            autocomplete="username" />
        </mat-form-field>
        <mat-error *ngIf="loginFormGroup.get('email')?.invalid && loginFormGroup.touched">
          Email is required
        </mat-error>

        <mat-form-field appearance="fill" class="width-full">
          <input
            matInput
            id="password"
            [type]="hidePassword ? 'password' : 'text'"
            required
            formControlName="password"
            placeholder="Password"
            autocomplete="current-password" />
          <button
            type="button"
            mat-icon-button
            matSuffix
            (click)="hidePassword = !hidePassword">
            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </mat-form-field>
        <mat-error *ngIf="loginFormGroup.get('password')?.invalid && loginFormGroup.touched">
          Password is required
        </mat-error>

        <div class="error-message" *ngIf="errorMessage">
          {{ errorMessage }}
        </div>

        <button
          mat-raised-button
          color="primary"
          type="submit"
          class="login-btn"
          [disabled]="loginFormGroup.invalid || isLoading">
          <span *ngIf="!isLoading">Login</span>
          <mat-spinner *ngIf="isLoading" diameter="20"></mat-spinner>
        </button>
      </form>

      <div class="divider">
        <span>or</span>
      </div>

      <div class="social-login">
        <asl-google-signin-button type="standard" size="large"></asl-google-signin-button>
      </div>
    </mat-card-content>

    <mat-card-footer class="login-footer">
      <span>Don't have an account?</span>
      <a (click)="navigateToRegister()" class="register-link">Register here</a>
    </mat-card-footer>
  </mat-card>
</div>
